export enum SagepayExportLogStatus {
    successful = 'successful',
    successfulWithErrors = 'successfulWithErrors',
    unsuccessful = 'unsuccessful',
}
